import {
  createBaseTransport,
  TransportEvent,
} from '@spotify-internal/transport/es5';
import { createProviders } from '@spotify-internal/transport/es5/providers/spotify_com';
import { requestTransformerCreator } from '@spotify-internal/transport/es5/plugins/request_transformer';

import type { Transport } from '@spotify-internal/transport';

/**
 * When running the service outside `www.spotify.com` expect to see
 * CORS issues, as this transport instance points to `www.spotify.com/api`.
 */
const transport = createBaseTransport({ providers: createProviders() });

/**
 * This is a necessary step in order to remove all Authorize headers
 * from all requests.
 */
transport.addPlugin(requestTransformerCreator, {
  optionsOverrides: {
    authorize: false,
  },
});

/**
 * Promise taking care of connecting + authenticating transport.
 * @returns {Transport} transport instance
 */
export function getAuthTransport() {
  return new Promise((resolve, reject) => {
    const doResolve = () => resolve(transport as unknown as Transport);
    transport.once(TransportEvent.CONNECTED, () => {
      if (!transport.isAuthenticated()) {
        transport.authenticate().then(() => doResolve(), reject);
      } else {
        doResolve();
      }
    });

    if (!transport.isConnected()) {
      transport.connect();
    } else {
      doResolve();
    }
  });
}
/**
 * When using this method, for example to avoid awaiting a Promise,
 * ensure you call `connect()` and, where needed, `authenticate()` on
 * the instance returned.
 * @returns {Transport} transport instance
 */
export function getTransport() {
  return transport as unknown as Transport;
}
